import { useState } from "react";
import axios from "axios";
import { mainURL } from "../../assets/constants/api";
import { useAuth } from "../../hooks/useAuth";
import { toast } from "react-toastify";

const ChangePasswordModal = ({ onClose }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { token } = useAuth();

  const validate = () => {
    if (!currentPassword || currentPassword.trim() === "") {
      setError("كلمة المرور الحالية لا يمكن أن تكون فارغة");
      return false;
    }
    if (!newPassword || newPassword.trim() === "") {
      setError("كلمة المرور الجديدة لا يمكن أن تكون فارغة");
      return false;
    }
    if (newPassword.length < 8) {
      setError("كلمة المرور الجديدة يجب أن تكون 8 أحرف على الأقل");
      return false;
    }
    if (newPassword !== confirmPassword) {
      setError("تأكيد كلمة المرور غير متطابق");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    setLoading(true);
    try {
      const res = await axios.post(
        `${mainURL}/web/user-settings/change-password`,
        {
          current_password: currentPassword,
          new_password: newPassword,
        
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(res.data.message || "تم تغيير كلمة المرور بنجاح");
      onClose();
    } catch (error) {
      console.error("فشل تغيير كلمة المرور:", error);
      setError(error.response?.data?.message || "حدث خطأ أثناء تغيير كلمة المرور");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 100,
        left: 20,
        width: "300px",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        zIndex: 10000,
      }}
    >
      <div
        className="absolute left-0 top-1/2 transform -translate-y-1/2 rounded-xl p-6 w-96 shadow-lg"
        style={{ background: "#391965" }}
      >
        <h4 className="text-lg font-bold mb-4 text-center">تغيير كلمة المرور</h4>

        <div className="mb-3 justify-content-center align-items-center d-flex flex-column">
          <label className="block mb-2 text-sm">كلمة المرور الحالية</label>
          <input
            type="password"
            className="w-full border p-2 rounded"
            value={currentPassword}
            onChange={(e) => {
              setCurrentPassword(e.target.value);
              setError("");
            }}
            style={{ background: "#210053", color: "white" }}
          />
        </div>

        <div className="mb-3 justify-content-center align-items-center d-flex flex-column">
          <label className="block mb-2 text-sm">كلمة المرور الجديدة</label>
          <input
            type="password"
            className="w-full border p-2 rounded"
            value={newPassword}
            onChange={(e) => {
              setNewPassword(e.target.value);
              setError("");
            }}
            style={{ background: "#210053", color: "white" }}
          />
        </div>

        <div className="mb-3 justify-content-center align-items-center d-flex flex-column">
          <label className="block mb-2 text-sm">تأكيد كلمة المرور الجديدة</label>
          <input
            type="password"
            className="w-full border p-2 rounded"
            value={confirmPassword}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
              setError("");
            }}
            style={{ background: "#210053", color: "white" }}
          />
        </div>

        {error && <p className="text-red-600 text-sm mb-2">{error}</p>}

        <div className="d-flex flex-row justify-content-center gap-2 mt-4">
          <button
            className="btn-warning text-dark px-4 py-2 rounded"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "جارٍ الإرسال..." : "تغيير"}
          </button>
          <button className="btn-danger px-4 py-2 rounded" onClick={onClose}>
            إلغاء
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;